import { CompanyMapper } from "app/company/company.mapper";
import { OrganizationTermsTranslation } from "./organization-terms-translation.model";

export class OrganizationTermsMapper {
  public static map(data: any): OrganizationTermsTranslation[] {
    if (!data || !Array.isArray(data)) {
      return [];
    }

    return data.map((item: any) => this.mapItem(item));
  }

  public static mapItem(item: any): OrganizationTermsTranslation {
    const company = item.company ? CompanyMapper.map(item.company) : null;
    return new OrganizationTermsTranslation(
      item.locale || "",
      company,
      {
        sea: item.fcl?.sea || "",
        rail: item.fcl?.rail || "",
        road: item.fcl?.road || "",
      },
      {
        sea: item.lcl?.sea || "",
        rail: item.lcl?.rail || "",
        road: item.lcl?.road || "",
      },
      item.air || "",
      item.ltl || "",
      item.ftl || "",
      item.ptl || "",
      item.manual || "",
      item.multi || "",
    );
  }
}
